export const convertObjectToQueryString = (obj) => {
  return Object.keys(obj)
    .filter((key) => !!obj[key])
    .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
    .join('&');
};
